module.exports = __webpack_public_path__ + "img/hip-valley-roof@2x.dee1ae89.png";